export default __webpack_public_path__ + "static/media/you-amaze-me.4ac7bc88.webp";